export default "__VITE_ASSET__BJ0M86GX__"